/** Shared pricing translation shape — imported by all locale files. */

import {
  WC2026_ORG_BILLING_DISCLOSURE,
  WC2026_ORG_BILLING_DISCLOSURE_SHORT,
} from '../../shared/constants/wc2026OrgBillingDisclosure.constants'

export const pricingTranslationsPt = {
  eyebrow: 'Pacotes e preços',
  perMonth: 'por mês',
  perYear: 'por ano',
  copy: {
    pageTitle: 'Planos e preços',
    pageSubtitle:
      'Um só lugar para comparar planos. Hobby é gratuito para todos. Pro é uma assinatura pessoal. Business é uma taxa única de org WC 2026 (não é Pro). Enterprise é negociado com nossa equipe.',
    comingSoonBadge: 'Em breve',
    comingSoonInProduction: 'Em breve em produção',
    mostPopularBadge: 'Mais popular',
    currentPlanBadge: 'Seu plano',
    createOrgCta: 'Criar organização',
    footnote:
      'Pro é cobrado na sua conta pessoal (sem org). Business é uma taxa única de organização WC 2026 — crie uma org, escolha o tier de assentos e pague uma vez pelo acesso org no período do torneio. Enterprise é para organizações que precisam de preços, limites ou contratos personalizados — fale conosco.',
    orgPlanDisclosure: WC2026_ORG_BILLING_DISCLOSURE,
    orgPlanDisclosureShort: WC2026_ORG_BILLING_DISCLOSURE_SHORT,
    footnoteCancelPolicy:
      'Se você cancelar o Pro no portal de cobrança, o Stripe mantém seu plano ativo até o fim do período pago — você pode retomar antes disso. O app sincroniza com o Stripe quando você voltar aqui.',
    signInToSubscribe: 'Entre para assinar',
    logIn: 'Entrar',
    goBack: 'Voltar',
    manageSubscription: 'Gerenciar assinatura',
    proAccessEndsOn: 'Acesso Pro termina em',
    billingIntervalMonth: 'Mensal',
    billingIntervalYear: 'Anual',
    switchToMonthly: 'Mudar para mensal',
    upgradeToYearlyDialogMsg:
      'A cobrança anual é um compromisso de 12 meses. Depois de mudar, você não poderá voltar ao plano mensal até o fim do período anual — sem reembolsos parciais.',
    upgradeToYearlyDialogConfirm: 'Mudar para anual',
    upgradeToYearlyDialogCancel: 'Manter mensal',
    switchToMonthlyDialogTitle: 'Mudar para Pro mensal',
    switchToMonthlyDialogMsg:
      'Você será direcionado ao Stripe para mudar para cobrança mensal. Seu acesso Pro anual continua até o fim do período atual — a cobrança mensal começa depois disso. Sem reembolso pelo tempo não utilizado.',
    switchToMonthlyConfirm: 'Ir para o Stripe',
    switchToMonthlyCancel: 'Manter anual',
    upgradeToYearlyProTitle: 'Upgrade para Pro anual',
    upgradeToYearlyProConfirm: 'Fazer upgrade',
    enterpriseSubscribe: 'Assinar',
    enterpriseCheckoutAdminOnly: 'Peça a um admin da org para assinar',
    upgradeSeatBucket: 'Upgrade',
    managePlan: 'Plano e cobrança',
    businessSubscribe: 'Assinar',
    upgradeMonthlyToYearlyDialog: {
      line1: 'Você está mudando de Pro mensal ({monthly}/month) para Pro anual ({yearly}/year).',
      line2:
        'Seu método de pagamento atual será cobrado pela diferença proporcional do período de cobrança em curso.',
      line3:
        'Depois de mudar para anual, você não poderá voltar ao plano mensal até o fim do período anual.',
      line4: 'Continuar?',
    },
  },
  plans: {
    hobby: {
      name: 'Hobby',
      priceLabel: 'Grátis',
      tagline: 'Para amigos e grupos pequenos que estão começando.',
      ctaLabel: 'Começar',
      features: [
        'Desafios e palpites principais',
        'Pontuação padrão (sem doubles)',
        'Linhas de partida padrão por desafio',
        'Suporte padrão',
        'Anúncios ocasionais',
        'Ideal para experimentar o Zporti com poucas pessoas',
      ],
    },
    proMonthly: {
      name: 'Pro · Mensal',
      tagline: 'Para jogadores solo e grupos de amigos que querem mais recursos.',
      ctaLabel: 'Assinar mensalmente',
      features: [
        'Tudo do Hobby',
        'Doubles habilitados',
        'Mais linhas de partida por desafio',
        'Experiência sem anúncios',
        'Limites maiores para membros e atividade',
        'Suporte prioritário',
        'Opções de branding mais fortes',
      ],
    },
    proYearly: {
      name: 'Pro · Anual',
      tagline: 'Os mesmos recursos Pro, cobrados uma vez por ano — ideal quando o grupo está comprometido a longo prazo.',
      ctaLabel: 'Assinar anualmente',
      features: [
        'Tudo do Hobby',
        'Doubles habilitados',
        'Mais linhas de partida por desafio',
        'Experiência sem anúncios',
        'Limites maiores para membros e atividade',
        'Suporte prioritário',
        'Opções de branding mais fortes',
      ],
    },
    business: {
      name: 'Business',
      priceLabel: 'From $450',
      tagline: 'Taxa única de org WC 2026. Escolha o tier de assentos e pague uma vez pelo acesso no torneio.',
      ctaLabel: 'Começar',
      features: [
        'Branding da organização (cores e logos)',
        'Assentos para membros — tiers fixos até 2.000',
        'Acesso org ao torneio WC 2026 (org com marca + equipe vinculada)',
        'Suporte prioritário',
        'Não inclui Pro pessoal, moedas, boosts nem compras na loja do app',
      ],
    },
    enterprise: {
      name: 'Enterprise',
      priceLabel: 'Personalizado',
      tagline: 'Preços e rollout org negociados para WC 2026 — definidos no seu pedido ou contrato.',
      ctaLabel: 'Fale conosco',
      features: [
        'Branding e rollout organizacional (conforme acordo)',
        'Limites de membros definidos com vendas',
        'WC 2026 e recursos org-wide (conforme acordo)',
        'Suporte dedicado e onboarding personalizado',
        'Integrações, faturamento e contratos personalizados',
        'Não inclui Pro pessoal, moedas, boosts nem compras na loja do app',
      ],
    },
  },
  seatBuckets: {
    upTo100: 'Até 100 funcionários',
    upTo250: 'Até 250 funcionários',
    upTo500: 'Até 500 funcionários',
    upTo1000: 'Até 1.000 funcionários',
    upTo2000: 'Até 2.000 funcionários',
  },
} as const

export const featuresSectionPt = {
  eyebrow: 'O que você ganha',
  livePreview: 'Prévia ao vivo',
  avatars: {
    title: 'Avatares personalizados para cada jogador',
    description:
      'Dê a cada pessoa uma identidade reconhecível para que rankings, rivalidades e provocações pareçam pessoais desde o primeiro dia.',
    accessibilityLabel: 'Prévia do recurso de avatares personalizados',
  },
} as const

export const footerExtendedPt = {
  product: 'Produto',
  compete: 'Competir',
  company: 'Empresa',
  phoneTagline: 'Palpites esportivos com amigos.',
  copyright: '© 2026 Zporti. Feito por fãs de futebol, para fãs de futebol.',
  copyrightShort: '© 2026 Zporti',
} as const

export const organizationsPt = {
  heroBadge: 'Para equipes, ligas e marcas',
  heroTitle: 'Organizações no Zporti',
  heroLead:
    'Gerencie seu grupo com identidade própria dentro do Zporti. Defina cores e logos da marca, convide membros com um código de entrada e gerencie assentos em um só lugar — para que todos vejam uma experiência coesa ao jogar e palpitar juntos.',
  valueSectionTitle: 'O que você ganha',
  valueBrandingTitle: 'Marca que parece sua',
  valueBrandingBody:
    'Envie seus logos, escolha cores primária e secundária e veja como aparecem na experiência. Admins mantêm o visual consistente sem mexer em código.',
  valueMembersTitle: 'Membros e assentos',
  valueMembersBody:
    'Crie uma organização ou entre com um código. Veja quem está dentro, gerencie capacidade com limites de assentos do seu plano e copie um código de entrada ao integrar novas pessoas.',
  valueMascotTitle: 'Mascote e avatares com marca',
  valueMascotBody:
    'Humores de mascote com marca e conjuntos de avatares exclusivos da organização ajudam sua comunidade a se destacar — ótimo para grupos de torcedores, ligas corporativas e parceiros.',
  howSectionTitle: 'Como funciona',
  howStep1: 'Entre e crie uma organização ou junte-se com um código de convite do seu admin.',
  howStep2: 'Admins abrem Configurações da organização para ajustar branding, membros e detalhes da conta.',
  howStep3: 'Membros usam o app normalmente, com os visuais e benefícios da sua organização onde estiverem habilitados.',
  signIn: 'Entrar',
  signUp: 'Criar conta',
  heroPanelTitle: 'Central da organização',
  heroPanelBody:
    'Convide membros, defina a marca e dê a cada grupo um espaço polido antes do apito inicial.',
} as const

export const b2bContactPt = {
  title: 'Prefere que a gente configure para você?',
  subtitle: 'Preencha seus dados e nossa equipe entrará em contato.',
  orgNameLabel: 'Nome da organização *',
  orgNamePlaceholder: 'Sua organização',
  contactNameLabel: 'Seu nome *',
  contactNamePlaceholder: 'Nome completo',
  emailLabel: 'E-mail *',
  emailPlaceholder: 'you@example.com',
  messageLabel: 'Mensagem',
  messagePlaceholder: 'Conte-nos sobre suas necessidades (opcional)',
  submitButton: 'Enviar solicitação',
  scheduleMemo: 'Ou agende uma ligação — em breve',
  errorFallbackValidation: 'Verifique seus dados e tente novamente.',
  errorFallbackSubmit: 'Falha no envio. Tente novamente.',
  successMessage: 'Obrigado! Recebemos sua solicitação e entraremos em contato em breve.',
} as const

export const signInPt = {
  signUpSubtitle: 'Cadastre-se para começar',
  signInSubtitle: 'Entre para continuar',
  emailPlaceholder: 'E-mail',
  passwordPlaceholder: 'Senha',
  forgotPassword: 'Esqueceu a senha?',
  signUpButton: 'Cadastrar',
  signInButton: 'Entrar',
  alreadyHaveAccount: 'Já tem uma conta? ',
  noAccount: 'Não tem uma conta? ',
  toggleSignIn: 'Entrar',
  toggleSignUp: 'Cadastrar',
  orDivider: 'OU',
  signInWith: 'Entrar com',
  continueAsGuest: 'ou continuar como convidado',
  legalConsentPrefix: 'Li e concordo com os ',
  legalConsentAnd: ' e ',
  legalConsentSuffix: '.',
  marketingConsent: 'Concordo em receber atualizações do produto e e-mails de marketing do Zporti.',
  loading: 'Carregando…',
  sendingResetEmail: 'Enviando e-mail de redefinição',
  signingUp: 'Cadastrando',
  signingIn: 'Entrando',
  continuingWithGoogle: 'Continuando com Google',
  continuingWithFacebook: 'Continuando com Facebook',
  enteringAsGuest: 'Entrando como convidado',
} as const

export const a11yPt = {
  openMenu: 'Abrir menu',
  closeMenu: 'Fechar menu',
  heroMascot: 'Mascote Zporti segurando um celular',
} as const

export const accountAdminSitePt = {
  backToSite: '← Voltar ao site',
} as const
